import { render, staticRenderFns } from "./prolstitem.vue?vue&type=template&id=f314b7f6&scoped=true"
import script from "./prolstitem.vue?vue&type=script&lang=js"
export * from "./prolstitem.vue?vue&type=script&lang=js"
import style0 from "./prolstitem.vue?vue&type=style&index=0&id=f314b7f6&prod&lang=scss&scoped=true"
import style1 from "./prolstitem.vue?vue&type=style&index=1&id=f314b7f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f314b7f6",
  null
  
)

export default component.exports